import { useEffect } from "react";

const useLogoutSync = () => {
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "logout") {
        sessionStorage.removeItem("login");
        localStorage.setItem("contactUs_reloaded", "false");
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);
};

export default useLogoutSync;
